let that;
import { zzsh,dwgl } from '@/axios'
import { Message } from 'element-ui'
import {bsid} from '@/common/common.js'
export default{
	data(){
		return{
			formData:{
				id:"",
				user_id:this.$store.state.user.userinfo.id, //登录id
				flag:this.$store.state.user.userinfo.flag, // 登录flag
				dwid:[],
				title:"",
				uid1:"",
				uid2:[],
				day:"",
				address:"",
				content:"",
				files:[]
			},
			zzlist:[],
			rules:{
				// 检测标题是否为空
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				// 检测谈话人是否为空
				uid1: [{ required: true, message: '请输入谈话人', trigger: 'blur' }],
				// 检测谈话对象是否为空
				dwid: [{ required: true, message: '请选择谈话对象', trigger: 'blur' }],
				// 检测活动类型是否为空
				day: [{ required: true, message: '请选择谈话时间', trigger: 'blur' }]
			}
		}
	},
	methods:{
		//删除文件
		delfile(index){
			this.formData.file.splice(index,1);
		},
		// 编辑绑定数据
		bindData(){
			zzsh.updateOrganTalkGet({
				id:that.$route.query.id
			}).then(res => {
				if(res.code == 200){
					for(let key in res.data){
						for(let index in that.formData){
							if(key === index){
								that.formData[key] = res.data[index];
							}
						}
					}
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		//提交
		submit(formData){
			that.$refs[formData].validate((valid) => {
				if (valid) {
					let length = that.formData.dwid.length;
					that.formData.uid2 = [that.formData.dwid[length-2],that.formData.dwid[length-1]]
					if(that.$route.query.type == 'edit'){
						// 编辑
						zzsh.updateOrganTalk(that.formData).then(res => {
							if(res.code == 200){
								that.$router.go(-1);
							}else{
								Message({
									type:"error",
									message:res.msg
								})
							}
						})
					}else{
						// 新增
						zzsh.addOrganTalk(that.formData).then(res => {
							if(res.code == 200){
								that.$router.go(-1);
							}else{
								Message({
									type:"error",
									message:res.msg
								})
							}
						})
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 上传文件成功
		success1(res, file) {
			var that = this;
			if(res.code == 200){
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					ment_url:res.data.src
				}
				that.formData.files.push(data)
			}else{
				Message({
					type:"error",
					message:"上传失败，请检查网络链接或文件类型"
				})
			}
		},
		// 上传进度
		uploadProcess(event, file, fileList) {
			var that = this;
			const loading = this.$loading({
				lock: true,
				text: '上传中请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			});
			if(Math.floor(event.percent) == 100){
				loading.close();
			}
		},
		// 参与组织列表
		organMember(){
			dwgl.organMember({
				flag:this.$store.state.user.userinfo.flag,
				user_id:this.$store.state.user.userinfo.id,
			}).then(res => {
				that.zzlist = res.data;
			})
		}
	},
	mounted() {
		that.organMember();
		if(that.$route.query.type == 'edit'){
			that.bindData();
		}
	},
	created() {
		that = this;
		that.$emit('selectTop',3)
	}
}